<template>
    <div class="container">
	<div id="wrapper" class="container">
	    <div class="page-msg-success">新手机号码更改成功</div>
	    <router-link to="/student/user/center" class="btn btn-gray btn-l">返回</router-link>
	</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
			}
		},
		methods:{
			
		},
		mounted(){
		},
		beforeDestroy(){
		},
		destroyed(){
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/student/user/phone-succeed.vue